var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7722 3.33913C14.0759 3.64288 14.0759 4.13534 13.7722 4.43908L7.54997 10.6613C7.24623 10.965 6.75377 10.965 6.45003 10.6613L0.227806 4.43908C-0.0759344 4.13534 -0.0759344 3.64288 0.227806 3.33913C0.531547 3.03539 1.02401 3.03539 1.32775 3.33913L7 9.01138L12.6723 3.33913C12.976 3.03539 13.4685 3.03539 13.7722 3.33913Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron_down_icon.9413e29acf018bb1d5631c21b4e00ee9.svg";
export { ForwardRef as ReactComponent };